import React from 'react';
import { AlertTriangleIcon, AlertCircleIcon, ClockIcon, FileWarningIcon } from 'lucide-react';
export function RiskSignals() {
  const risks = [{
    id: 1,
    label: 'LOs Under Activity Threshold',
    value: '8 LOs',
    severity: 'high',
    icon: AlertTriangleIcon,
    detail: '< 20 calls/day'
  }, {
    id: 2,
    label: 'Stale Pipeline % (> 45 days)',
    value: '24%',
    severity: 'medium',
    icon: ClockIcon,
    detail: '+4% vs last week'
  }, {
    id: 3,
    label: 'Lock Fallout Rate',
    value: '18%',
    severity: 'high',
    icon: AlertCircleIcon,
    detail: 'Target: < 12%'
  }, {
    id: 4,
    label: 'Low Doc-on-First-Call',
    value: '15%',
    severity: 'medium',
    icon: FileWarningIcon,
    detail: 'Bottom quartile avg'
  }, {
    id: 5,
    label: 'Low Lock-to-Fund',
    value: '62%',
    severity: 'low',
    icon: ActivityIcon,
    detail: 'Industry avg: 75%'
  }];
  // Helper to fix the icon component usage
  function ActivityIcon(props: any) {
    return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-115">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" data-id="element-116" />
      </svg>;
  }
  return <div className="bg-slate-800 border border-slate-700 rounded-lg p-6 h-full" data-id="element-117">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2" data-id="element-118">
        <AlertTriangleIcon className="w-5 h-5 text-amber-400" data-id="element-119" />
        Risk Signals
      </h3>

      <div className="space-y-3" data-id="element-120">
        {risks.map(risk => <div key={risk.id} className="flex items-center justify-between p-3 rounded bg-slate-900/40 border border-slate-700/50 hover:bg-slate-900/60 transition-colors" data-id="element-121">
            <div className="flex items-center gap-3" data-id="element-122">
              <div className={`p-1.5 rounded-full ${risk.severity === 'high' ? 'bg-rose-500/20 text-rose-400' : risk.severity === 'medium' ? 'bg-amber-500/20 text-amber-400' : 'bg-blue-500/20 text-blue-400'}`} data-id="element-123">
                <risk.icon className="w-4 h-4" data-id="element-124" />
              </div>
              <div data-id="element-125">
                <p className="text-sm font-medium text-slate-200" data-id="element-126">
                  {risk.label}
                </p>
                <p className="text-xs text-slate-500" data-id="element-127">{risk.detail}</p>
              </div>
            </div>
            <div className="text-right" data-id="element-128">
              <span className={`text-sm font-bold ${risk.severity === 'high' ? 'text-rose-400' : risk.severity === 'medium' ? 'text-amber-400' : 'text-blue-400'}`} data-id="element-129">
                {risk.value}
              </span>
            </div>
          </div>)}
      </div>
    </div>;
}